export var AUTOCOMPLETE_VALUES = [
    { value: "given_name", text: "Primeiro nome" },
    { value: "family_name", text: "Sobrenome" },
    { value: "name", text: "Nome completo" },
    { value: "preferred_username", text: "Nome preferido" },
    { value: "cpf", text: "CPF" },
    { value: "dataNascimento", text: "Data de nascimento" },
    { value: "nomeMae", text: "Nome da mãe" },
    { value: "email", text: "Email" },
    { value: "celular", text: "Celular" },
    { value: "cep", text: "CEP" },
    { value: "bairro", text: "Bairro" },
    { value: "logradouro", text: "Logradouro" },
    { value: "tipoLogradouro", text: "Tipo de logradouro" },
    { value: "numero", text: "Número" },
    { value: "complemento", text: "Complemento" },
    { value: "cidade", text: "Cidade" },
    { value: "uf", text: "UF" },
];
